import React from 'react';
import { Paper } from '@mui/material';

export const REPORTS_BLOCK_BORDER_COLOR =  '#d7ddde';

const noShadowStyle = {
  border: `1px solid ${REPORTS_BLOCK_BORDER_COLOR}`,
  borderRadius: 12,
};

function PaperableHOC({
  children,
  noPaper,
  paperStyle,
  optClassName,
  noShadow,
  ...props
}) {
  return noPaper ? children : (
    <Paper
      className={optClassName}
      style={{
        ...(paperStyle ?? {}),
        ...(noShadow ? noShadowStyle : {}),
      }}
      elevation={noShadow ? 0 : 1}
      square
      {...props}
    >
      {children}
    </Paper>
  );
}

export default PaperableHOC;
